






























import { defineComponent } from "@vue/composition-api";
import LandingButton from "../LandingButton";
import LandingContainer from "../LandingContainer";

export default defineComponent({
  name: "JoinWideBlock",
  components: { LandingButton, LandingContainer },
});
